module.exports = __webpack_public_path__ + "static/media/Ex1-S0-SectionBreak.76ea44f1.PNG";